import { CollapsibleSection } from "components/collapsibleSection";
import { Tag } from "components/tag";
import { IPickupSportParticipantDetail } from "interfaces";
import moment from "moment";
import { getSelfPickupStatus } from "utills/helpers";

export const PickupInformationSection = ({participantDetailData} : {participantDetailData: IPickupSportParticipantDetail | null}) => {
  return (
    <CollapsibleSection 
      label="Pickup Information"
      defaultOpen={true}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-1">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup email
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.email_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.name_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">
              POS name 
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.pos}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-7">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup at
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.pick_time ? moment(participantDetailData.participant.pick_time).format("DD/MM/YYYY HH:mm:ss") : ""}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-9">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup image
            </p>
          </div>
          <div className="col-span-4">
            <p>
            {participantDetailData?.participant.image_pick ? <img className="w-auto max-w-full max-h-20" src={participantDetailData?.participant.image_pick} alt="PickupImage" /> : ""}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup ID/Passport
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.id_card_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup phone
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {participantDetailData?.participant.phone_pick}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">
              eWaiver status
            </p>
          </div>
          <div className="col-span-4">
            <Tag 
              text={participantDetailData?.participant?.is_online_checkin ? "Signed" : "Unsigned"}
              type={participantDetailData?.participant?.is_online_checkin ? "green" : "pink"}
            />
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-8">
          <div className="col-span-2">
            <p className="font-medium">
              Pickup Method
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {getSelfPickupStatus(participantDetailData?.participant.self_pick)}
            </p> 
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-10">
          <div className="col-span-2">
            <p className="font-medium">
              Digital-Signature
            </p>
          </div>
          <div className="col-span-4">
            {participantDetailData?.participant.signature ? <img className="w-auto max-w-full max-h-20" src={participantDetailData?.participant.signature} alt="signature" /> : ""}
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}